import React from 'react'
import Font from '@cred/react-font'
import CtaButton from 'components/cta-button'
import PropTypes from 'prop-types'
import box from './images/box-icon.png'
import styles from './styles.module.scss'

const EmptyList = ({ resetFilters }) => (
  <div className="align-center">
    <img src={box} alt="no lenders found" className={`${styles.box} mb-24 mt-48`} />
    <Font type="bodyLarge" weight="bold" color="neutral" className="mb-24">
      Oh no! We couldn’t find you any results
    </Font>
    <CtaButton small className="mb-48" onClick={resetFilters}>Reset Filter</CtaButton>
  </div>
)

EmptyList.propTypes = {
  resetFilters: PropTypes.func,
}

export { EmptyList }

export default EmptyList
